(function () {
  'use strict';

  function boot(root) {
    var variantData = root.querySelector('[data-imdtf-variants]');
    var variantInput = root.querySelector('[data-imdtf-variant]');
    var price = root.querySelector('[data-imdtf-price]');
    var atc = root.querySelector('[data-imdtf-atc]');
    var status = root.querySelector('[data-imdtf-status]');
    var form = root.querySelector('[data-imdtf-form]');
    var mainImage = root.querySelector('.imdtf__main-image');
    var variants = [];

    try { variants = JSON.parse(variantData ? variantData.textContent : '[]'); } catch (error) { variants = []; }

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function selectedOption(index) {
      var selected = root.querySelector('[data-imdtf-option][data-option-index="' + index + '"][aria-checked="true"]');
      return selected ? selected.getAttribute('data-option-value') : null;
    }

    function updateVariant() {
      var selected = variants.find(function (variant) {
        for (var index = 1; index <= 3; index += 1) {
          var value = selectedOption(index);
          if (value && variant['option' + index] !== value) return false;
        }
        return true;
      });

      if (!selected) {
        if (variantInput) variantInput.value = '';
        if (atc) { atc.disabled = true; atc.textContent = 'Combination unavailable'; }
        if (status) status.textContent = 'Choose another listed option.';
        return;
      }

      if (variantInput) variantInput.value = selected.id;
      if (price) price.textContent = money(selected.price);
      if (atc) {
        atc.disabled = !selected.available;
        atc.textContent = selected.available ? 'Add transfer to cart' : 'Unavailable';
      }
      if (status) status.textContent = selected.available ? '' : 'This option is currently unavailable.';

      var url = new URL(window.location.href);
      url.searchParams.set('variant', selected.id);
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-imdtf-option]');
      if (option) {
        var index = option.getAttribute('data-option-index');
        root.querySelectorAll('[data-imdtf-option][data-option-index="' + index + '"]').forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-checked', 'false');
        });
        option.classList.add('is-active');
        option.setAttribute('aria-checked', 'true');
        updateVariant();
        return;
      }

      var thumb = event.target.closest('[data-imdtf-thumb]');
      if (thumb && mainImage) {
        mainImage.src = thumb.getAttribute('data-image-url');
        mainImage.alt = thumb.getAttribute('data-image-alt') || mainImage.alt;
        root.querySelectorAll('[data-imdtf-thumb]').forEach(function (button) { button.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          try {
            var result = Shopify.analytics.publish('inkmerge:dtf_add_to_cart_attempt', {
              productId: root.getAttribute('data-product-id') || '',
              variantId: variantInput ? variantInput.value : ''
            });
            if (result && typeof result.catch === 'function') result.catch(function () {});
          } catch (error) {}
        }
      });
    }

    updateVariant();
  }

  function init() {
    document.querySelectorAll('[data-imdtf]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
